import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import { Entities, fetchById, getUpdatedEntity, patch } from 'src/common/index';
import ErrorMessage from 'src/components/misc/error-message';
import StarRatingEditForm from 'src/components/admin/star-rating/star-rating-edit-form';

class StarRatingEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = { startedFetching: false };
    }

    componentWillMount() {
        const { id } = this.props;

        this.props.fetchById(id, Entities.STAR_RATING);
    }

    componentWillReceiveProps(nextProps) {
        const { starRating } = nextProps;

        if (!this.state.startedFetching && starRating.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { starRating, t } = this.props;

        const finishFetching = this.state.startedFetching && !starRating.isFetching;

        if (finishFetching) {
            // check for errors
            if (starRating.error) return <ErrorMessage object={starRating} />;
            // if everything is ok populate form
            else {
                let initialValues = {};

                // populate form for editing an existing starRating
                if (starRating.content)
                    initialValues = {
                        id: starRating.content.id,
                        stars: starRating.content.stars,
                        rating: starRating.content.rating || 0,
                    };

                return (
                    <StarRatingEditForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        starRating={starRating.content}
                        t={t}
                        ref={ref => (this.childForm = ref)}
                    />
                );
            }
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { handleClose } = this.props;

        this.props.patch(data, Entities.STAR_RATING);

        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        starRating: getUpdatedEntity(state, Entities.STAR_RATING),
    };
};

export default connect(mapStateToProps, { fetchById, patch }, null, { withRef: true })(StarRatingEditModal);
